<template>
  <LayoutLanding>
    <div class="conocenos-page">
      <section class="conocenos-hero">
        <div class="overlay-location">
          <h1>CONÓCENOS</h1>
          <p>Te contamos quiénes somos, nuestra historia y cómo puedes formar tu propia franquicia de SPARK81</p>
        </div>
      </section>
      <section class="conocenos-container">
        <div class="conocenos-content">
          <h2>¿Qué es SPARK81?</h2>
          <p>
            SPARK81 es el nuevo referente en salas de acción arcade, donde la tecnología interactiva, los desafíos digitales y la acción física se combinan para ofrecer una experiencia inmersiva sin igual. En nuestras salas, jugarás en equipo, poniendo a prueba cuerpo y mente en un entorno de alta energía.
          </p>
          <p>
            Nos apasiona transformar el ocio urbano con experiencias que desafían las reglas y llevan el juego al siguiente nivel. ¡Bienvenido a SPARK81!
          </p>
        </div>
      </section>

      <section class="conocenos-container conocenos-bg historia-section">
        <div class="historia-content conocenos-content">
          <div class="historia-text">
            <h2>Nuestra Historia</h2>
            <p>
              Detrás de SPARK81 está Teaming Labs, especialistas en gamificación y actividades de team building. Colaboramos con The City Escape Room, expertos en la gestión de experiencias de ocio inmersivo, para llevar este concepto al siguiente nivel.
            </p>
            <p>
              Desde la apertura de nuestro primer centro en Terrassa en 2023, hemos redefinido la manera en que las personas disfrutan del entretenimiento, fusionando acción, tecnología y diversión en equipo.
            </p>
          </div>
          <div class="historia-img">
            <img src="@/assets/images/team.jpg" alt="Nuestra Historia">
          </div>
        </div>
      </section>

      <section class="conocenos-container">
        <div class="conocenos-content">
          <h2>SPARK81 en los Medios</h2>
          <p>
            SPARK81 ha revolucionado el entretenimiento urbano con su innovadora propuesta de juegos arcade inmersivos. Con desafíos adaptados a diferentes niveles, somos el destino ideal para quienes buscan acción, adrenalina y un nuevo concepto de diversión.
          </p>
          <br>
          <p><strong>Correo Electrónico:</strong> hola@spark81.com</p>
          <p><strong>Teléfono:</strong> +34 624 329 890</p>
          <p><strong>Redes Sociales:</strong></p>
          <ul>
            <li><strong>Instagram:</strong> @playspark81</li>
            <li><strong>TikTok:</strong> @playspark81</li>
          </ul>
        </div>
      </section>

      <section class="conocenos-container conocenos-bg">
        <div class="conocenos-content">
          <h2>¿Quieres abrir un SPARK81?</h2>
          <p>
            SPARK81 está en plena expansión y buscamos socios que quieran traer el futuro del entretenimiento inmersivo a nuevas ciudades. Te ofrecemos un modelo de negocio sólido y un concepto de ocio que está marcando tendencia.
          </p>
          <h3>¿Por qué unirte a SPARK81?</h3>
          <ul>
            <li><strong>Innovación y Diferenciación:</strong> Somos pioneros en fusionar acción física y desafíos digitales.</li>
            <li><strong>Alta Rentabilidad:</strong> Un modelo probado con retorno de inversión atractivo.</li>
            <li><strong>Soporte Completo:</strong> Desde la selección del local hasta la apertura, te acompañamos en cada paso.</li>
          </ul>
          <p>
            Si quieres más información sobre cómo traer SPARK81 a tu ciudad, contáctanos y te guiaremos en el proceso.
          </p>
          <div class="second-button">
              <a href="#" @click.prevent="() => {$router.push('/contact')}">PONTE EN CONTACTO</a>
            </div>
        </div>
      </section>

    </div>
  </LayoutLanding>
</template>

<script>
import LayoutLanding from "@/components/LayoutLanding.vue";

export default {
  components: {
    LayoutLanding
  }
};
</script>
